import {SET_SELECTED_CALENDAR} from "../constants";


export const setSelectedCalendarAction = (selectedCalendar, startDate, localStartTime) => async dispatch => {
    dispatch({ type: SET_SELECTED_CALENDAR, payload: {...selectedCalendar, startDate, localStartTime}})
}

export const resetSelectedCalendarAction = (selectedCalendar) => async dispatch => {
    dispatch({ type: SET_SELECTED_CALENDAR, payload: {...selectedCalendar, startDate: '', localStartTime: ''}})
}